import { useState } from "react"
import dayjs from "@/lib/dayjs";
import { getRandomPlaceholderImage } from "./data/photo-data"
import { Link } from "@inertiajs/react"
import { BidBadgeWithCountdownSearch } from "./BidBadgeWithCountdownSearch"

export const ItemList = ({ item }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [isHovering, setIsHovering] = useState(false)
  const targetTime = dayjs.utc(item.ending_time).tz("America/New_York")

  const images = item?.gun ? item.gun.photo_array : item.photo_array

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  const handleImageError = (e) => {
    // Idempotent: assigning src re-fires error when the placeholder fails too,
    // so bail out once a placeholder is already showing.
    if (e.target.src.includes("/images/static/gun-skele")) {
      return
    }

    e.target.srcset = ""
    e.target.src = getRandomPlaceholderImage()
  }

  if (!item.gunbroker_item_id) {
    return null
  }

  return (
    <Link
      href={route("item", {
        auction: item.gunbroker_item_id,
      })}
      className={`relative flex px-3 py-2 hover:bg-[#f3f4f6] rounded-lg font-medium text-[15px] text-[#000] hover:h-[100px] gap-3 ${
        isHovering ? "" : "items-center"
      }`}
      key={item.id}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <img
        src={
          imageLoaded
            ? images[0].replaceAll('"', "")
            : getRandomPlaceholderImage()
        }
        alt={item?.gun ? item.gun.title_for_gunbroker : item.title_for_gunbroker}
        className="relative z-0 w-20 h-14 rounded"
        onError={handleImageError}
        loading="lazy"
        onLoad={handleImageLoad}
      />
      {isHovering && !item.is_sold && (
        <BidBadgeWithCountdownSearch
          className="absolute bottom-2"
          targetTime={targetTime}
          gunbroker_item_id={item.gunbroker_item_id}
        />
      )}
      {isHovering && item.is_sold && (
        <span className="absolute text-[10px] rounded bottom-2 text-white w-20 flex justify-center font-bold bg-[#34a853] px-2 py-1">
          SOLD
        </span>
      )}
      <span className="flex overflow-hidden text-ellipsis ellipsis-1">
        {item.gun.title_for_gunbroker}
      </span>
    </Link>
  )
}
